// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetMarketTrandRequest,
  TGetMarketTrandModel,
  IMappers,
  TGetMarketTrandResponse,
  IGetMarketTrandResponse,
  IGetMarketTrandResponseError,
} from './types';

export const defaultConfig: TGetMarketTrandModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'valuation-offer-history',
  pathApi: '/v1/get-market-trand/',
} as TGetMarketTrandModel;

export function createGetMarketTrandModel(parameters: IGetMarketTrandRequest): TGetMarketTrandModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetMarketTrandOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetMarketTrandRequest;
}

export async function fetchGetMarketTrand<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetMarketTrandOptions<TResponse200, TResponse400>): Promise<TGetMarketTrandResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetMarketTrandModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetMarketTrandResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetMarketTrandResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetMarketTrandResponse;
}
